import { render, staticRenderFns } from "./OfficialWebsiteResearch.vue?vue&type=template&id=529c78c8&scoped=true"
import script from "./OfficialWebsiteResearch.vue?vue&type=script&lang=js"
export * from "./OfficialWebsiteResearch.vue?vue&type=script&lang=js"
import style0 from "./OfficialWebsiteResearch.vue?vue&type=style&index=0&id=529c78c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529c78c8",
  null
  
)

export default component.exports